import Observer from '../classes/Observer';
import { maybePlayAutoplayVideo } from './AutoplayVideos';

class LazyVideos extends Observer {
  private $targets: JQuery;

  constructor() {
    super({
      isOnce: true,
    });
    this.$targets = $('video, iframe[data-src]');
    this.observe(this.$targets);
  }

  animateIn(target: HTMLVideoElement) {
    super.animateIn();

    const $target = $(target);

    if ($target.is('video')) {
      const $sources = $(target).find('source');
      $sources.each((i, s) => {
        const source = s;
        if (typeof source.tagName === 'string' && source.tagName === 'SOURCE') {
          const src = source.dataset.src;
          source.src = src || '';
        }
      });
      target.load();
      maybePlayAutoplayVideo(target);
    } else {
      const src = target.dataset.src;
      if (src) {
        target.src = src;
      }
    }
  }
}

export default LazyVideos;
